export const gmbLocationSyncLogConst = {
  locationName: 'location_name',
  description: 'description',
  websiteUrl: 'website_url',
  addressLines: 'address_lines',
  administrativeArea: 'administrative_area',
  postalCode: 'postal_code',
  primaryPhone: 'primary_phone',
  additionalPhones: 'additional_phones',
  payDebitCard: 'pay_debit_card',
  requiresCashOnly: 'requires_cash_only',
  payCheck: 'pay_check',
  payMobileNfc: 'pay_mobile_nfc',
  payCreditCardTypesAccepted: 'pay_credit_card_types_accepted',
  regularHours: 'regular_hours',
  primaryCategory: 'primary_category',
  additionalCategories: 'additional_categories',
  attributes: 'attributes',
  openInfo: 'open_info',
  storeCode: 'store_code',
}
